import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  Alert,
  Button,
  Typography,
} from "@mui/material";
import { useGetApprovalLogsQuery } from "../../../services/invoices/InvoiceApiSlice";
import { IApprovalLog } from "../../../utils/types";

const ApprovalLogsDrowdown = ({ id }) => {
  const {
    data: approvalLogs,
    isLoading,
    isError,
    refetch,
  } = useGetApprovalLogsQuery(id, { skip: !id });

  return (
    //   <Modal open={isOpen} onClose={handleClose}>
    //     <Box
    //       sx={{
    //         position: "absolute",
    //         top: "50%",
    //         left: "50%",
    //         transform: "translate(-50%, -50%)",
    //         width: 1000,
    //         maxHeight: "80vh",
    //         overflowY: "auto",
    //         bgcolor: "background.paper",
    //         boxShadow: 24,
    //         borderRadius: 2,
    //         p: 4,
    //       }}
    //     >
    //       <Stack direction="column" spacing={2}>
    //         <Typography variant="h6" component="h2" fontWeight="bold">
    //           Approval Logs
    //         </Typography>
    <>
      {isLoading ? (
        <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
          <CircularProgress />
        </Box>
      ) : isError ? (
        <Alert
          severity="error"
          action={
            <Button color="inherit" size="small" onClick={refetch}>
              Retry
            </Button>
          }
        >
          Failed to fetch approval logs.
        </Alert>
      ) : approvalLogs?.logs?.length === 0 ? (
        <Typography variant="subtitle1">No Logs found</Typography>
      ) : (
        <TableContainer component={Paper} sx={{ maxHeight: "60vh" }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell sx={headerCellStyle}>Sent by ID</TableCell>
                <TableCell sx={headerCellStyle}>Sent by Name</TableCell>
                <TableCell sx={headerCellStyle}>Action</TableCell>
                <TableCell sx={headerCellStyle}>Sent to ID</TableCell>
                <TableCell sx={headerCellStyle}>Sent to Name</TableCell>
                <TableCell sx={headerCellStyle}>Comments</TableCell>
                <TableCell sx={headerCellStyle}>Action Date</TableCell>
                <TableCell sx={headerCellStyle}>Action Time</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {approvalLogs?.logs?.map((row: IApprovalLog, index) => (
                <TableRow
                  key={index}
                  sx={{
                    backgroundColor:
                      index % 2 === 0 ? "background.default" : "grey.100",
                  }}
                >
                  <TableCell>{row?.sent_by_id}</TableCell>
                  <TableCell>{row?.sent_by_name}</TableCell>
                  <TableCell>{row?.action}</TableCell>
                  <TableCell>{row?.sent_to_id}</TableCell>
                  <TableCell>{row?.sent_to_name}</TableCell>
                  <TableCell sx={{ whiteSpace: "pre-wrap", maxWidth: 200 }}>
                    {row?.comments}
                  </TableCell>
                  <TableCell>{row?.action_date}</TableCell>
                  <TableCell>{row?.action_time}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </>
    //     </Stack>
    //   </Box>
    // </Modal>
  );
};

const headerCellStyle = {
  backgroundColor: "#f5f5f5",
  fontWeight: "bold",
  color: "#333",
};

export default ApprovalLogsDrowdown;
